/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseListTemplateFolder } from '../models/api-response-list-template-folder';
import { ApiResponsePagedResultTemplateFolder } from '../models/api-response-paged-result-template-folder';
import { ApiResponseTemplateFolder } from '../models/api-response-template-folder';
import { archiveTemplateFolder } from '../fn/template-folder-api/archive-template-folder';
import { ArchiveTemplateFolder$Params } from '../fn/template-folder-api/archive-template-folder';
import { createTemplateFolder } from '../fn/template-folder-api/create-template-folder';
import { CreateTemplateFolder$Params } from '../fn/template-folder-api/create-template-folder';
import { getTemplateFolder } from '../fn/template-folder-api/get-template-folder';
import { GetTemplateFolder$Params } from '../fn/template-folder-api/get-template-folder';
import { listTemplateFolder } from '../fn/template-folder-api/list-template-folder';
import { ListTemplateFolder$Params } from '../fn/template-folder-api/list-template-folder';
import { searchTemplateFolder } from '../fn/template-folder-api/search-template-folder';
import { SearchTemplateFolder$Params } from '../fn/template-folder-api/search-template-folder';
import { updateTemplateFolder } from '../fn/template-folder-api/update-template-folder';
import { UpdateTemplateFolder$Params } from '../fn/template-folder-api/update-template-folder';

@Injectable({ providedIn: 'root' })
export class TemplateFolderApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getTemplateFolder()` */
  static readonly GetTemplateFolderPath = '/v1/api/ui/templateFolder/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTemplateFolder()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTemplateFolder$Response(params: GetTemplateFolder$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseTemplateFolder>> {
    return getTemplateFolder(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTemplateFolder$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTemplateFolder(params: GetTemplateFolder$Params, context?: HttpContext): Observable<ApiResponseTemplateFolder> {
    return this.getTemplateFolder$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseTemplateFolder>): ApiResponseTemplateFolder => r.body)
    );
  }

  /** Path part for operation `updateTemplateFolder()` */
  static readonly UpdateTemplateFolderPath = '/v1/api/ui/templateFolder/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTemplateFolder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTemplateFolder$Response(params: UpdateTemplateFolder$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseTemplateFolder>> {
    return updateTemplateFolder(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTemplateFolder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTemplateFolder(params: UpdateTemplateFolder$Params, context?: HttpContext): Observable<ApiResponseTemplateFolder> {
    return this.updateTemplateFolder$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseTemplateFolder>): ApiResponseTemplateFolder => r.body)
    );
  }

  /** Path part for operation `archiveTemplateFolder()` */
  static readonly ArchiveTemplateFolderPath = '/v1/api/ui/templateFolder/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `archiveTemplateFolder()` instead.
   *
   * This method doesn't expect any request body.
   */
  archiveTemplateFolder$Response(params: ArchiveTemplateFolder$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseTemplateFolder>> {
    return archiveTemplateFolder(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `archiveTemplateFolder$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  archiveTemplateFolder(params: ArchiveTemplateFolder$Params, context?: HttpContext): Observable<ApiResponseTemplateFolder> {
    return this.archiveTemplateFolder$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseTemplateFolder>): ApiResponseTemplateFolder => r.body)
    );
  }

  /** Path part for operation `createTemplateFolder()` */
  static readonly CreateTemplateFolderPath = '/v1/api/ui/templateFolder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTemplateFolder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTemplateFolder$Response(params: CreateTemplateFolder$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseTemplateFolder>> {
    return createTemplateFolder(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createTemplateFolder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTemplateFolder(params: CreateTemplateFolder$Params, context?: HttpContext): Observable<ApiResponseTemplateFolder> {
    return this.createTemplateFolder$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseTemplateFolder>): ApiResponseTemplateFolder => r.body)
    );
  }

  /** Path part for operation `searchTemplateFolder()` */
  static readonly SearchTemplateFolderPath = '/v1/api/ui/templateFolder/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchTemplateFolder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTemplateFolder$Response(params: SearchTemplateFolder$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultTemplateFolder>> {
    return searchTemplateFolder(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchTemplateFolder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTemplateFolder(params: SearchTemplateFolder$Params, context?: HttpContext): Observable<ApiResponsePagedResultTemplateFolder> {
    return this.searchTemplateFolder$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultTemplateFolder>): ApiResponsePagedResultTemplateFolder => r.body)
    );
  }

  /** Path part for operation `listTemplateFolder()` */
  static readonly ListTemplateFolderPath = '/v1/api/ui/templateFolder/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listTemplateFolder()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTemplateFolder$Response(params: ListTemplateFolder$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListTemplateFolder>> {
    return listTemplateFolder(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listTemplateFolder$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTemplateFolder(params: ListTemplateFolder$Params, context?: HttpContext): Observable<ApiResponseListTemplateFolder> {
    return this.listTemplateFolder$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListTemplateFolder>): ApiResponseListTemplateFolder => r.body)
    );
  }

}
